export default "__VITE_ASSET__bf2fd561__"